import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO, ESTATUS_CANCELADO } from 'utils/constants';

export const baseURI = 'estructura-organizacional/movimientos-de-personal';
export const baseURIOptimized = 'estructura-organizacional/movimientos-de-personal-vista-optimized/';

/**
 * GET Movimientos de Personal (vista optimizada)
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getMovimientosDePersonal = async (params) => {
  try {
    const response = await API.get(baseURIOptimized, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Movimiento de Personal por ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getMovimientoDePersonal = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * PATCH Movimiento de Personal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMovimientoDePersonal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Movimiento de Personal
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteMovimientoDePersonal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Movimiento de Personal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarMovimientoDePersonal = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * CANCELAR Movimiento de Personal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const cancelarMovimientoDePersonal = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_CANCELADO });
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Generar backfill de movimientos
 * @returns {Promise<object|boolean>}
 */
export const generarBackfillMovimientos = async () => {
  try {
    const response = await API.post(`${baseURI}/generar-backfill/`);
    onSuccess(response, 'Generación de movimientos iniciada');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
